export default function wireSearchListeners(segment, ctx) {
    const { $uiEvents } = ctx
    $uiEvents.$on('searched', ({ query }) => {
        segment.track('Products Searched', {
            query: query.toLowerCase(),
        })
    })

    $uiEvents.$on('noSearchResults', (query) => {
        segment.track('Search - No Results', {
            emptySearchTerm: query.toLowerCase(),
        })
    })
}
